// @flow
import React from 'react';

import { withTheme } from '@material-ui/core/styles';
import { Fab } from '@material-ui/core';
import { Idle, NotIdle } from 'idlejs/dist';
import MenuOutlinedIcon from '@material-ui/icons/MenuOutlined';
import { getIsMac } from '../../utils/electron';
import useNetwork from '../../hooks/useNetwork';

const fabStyle = {
  position: 'absolute',
  zIndex: 101,
  right: 20,
};

interface IProps {
  fullScreen: boolean;
  theme: Object;
  updateFullScreen: Function;
}

function FullScreenHamburger(props: IProps) {
  const [idle, setIdle] = React.useState(false);
  const online = useNetwork();

  React.useEffect(() => {
    const idle = new Idle()
      .whenNot([
        {
          events: ['click', 'mousemove', 'mouseenter', 'keydown', 'touchstart'],
          target: window.document,
        },
      ])
      .whenNotInteractive()
      .within(3, 1000)
      .do(() => {
        setIdle(true);
      })
      .start();
    const notIdle = new NotIdle()
      .when([
        {
          events: ['click', 'mousemove', 'mouseenter', 'keydown', 'touchstart'],
          target: window.document,
        },
      ])
      .within(1, 300)
      .do(() => setIdle(false))
      .start();

    return () => {
      idle.stop();
      notIdle.stop();
    };
  }, []);

  const { theme, fullScreen, updateFullScreen } = props;

  let heightOffset = '';
  if (window.isElectron) {
    if (getIsMac()) {
      heightOffset = ' - 28px';
    } else {
      heightOffset = ' - 32px';
    }
  }

  return (
    <div
      style={{
        overflowX: 'hidden',
        position: 'absolute',
        backgroundColor: theme.palette.background.default,
        display: fullScreen && !idle ? undefined : 'none',
        height: `calc(var(--vh, 1vh) * 100${heightOffset})`,
        width: '100px',
        fontFamily: theme.typography.fontFamily,
      }}
    >
      <Fab
        onClick={e => {
          updateFullScreen(e);
          // $FlowFixMe
          if (document.fullscreenElement && document.exitFullscreen) document.exitFullscreen();
        }}
        style={{ ...fabStyle, top: online ? 20 : 80 }}
      >
        <MenuOutlinedIcon style={{ fontSize: 30, cursor: 'pointer', outline: 'none' }} />
      </Fab>
    </div>
  );
}

export default withTheme(FullScreenHamburger);
